export const DISCLAIMER = `*היתרה אינה מהווה יתרה לסילוק ואינה כוללת עמלה תפעולית, ריבית שנצברה, ריביות פיגורים, הצמדות והוצאות משפטיות - ככל וקיימות`